module.exports = {
  flags: [
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/320/apple/237/flag-for-united-states_1f1fa-1f1f8.png',
      value: 'en-us'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-saudi-arabia_1f1f8-1f1e6.png',
      value: 'ar-ar'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-china_1f1e8-1f1f3.png',
      value: 'zh-cn'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-netherlands_1f1f3-1f1f1.png',
      value: 'nl-nl'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-france_1f1eb-1f1f7.png',
      value: 'fr-fr'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-canada_1f1e8-1f1e6.png',
      value: 'fr-ca'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-germany_1f1e9-1f1ea.png',
      value: 'de-de'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-india_1f1ee-1f1f3.png',
      value: 'hi-in'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-italy_1f1ee-1f1f9.png',
      value: 'it-it'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-japan_1f1ef-1f1f5.png',
      value: 'ja-jp'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-south-korea_1f1f0-1f1f7.png',
      value: 'ko-kr'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-brazil_1f1e7-1f1f7.png',
      value: 'pt-br'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-spain_1f1ea-1f1f8.png',
      value: 'es-es'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-mexico_1f1f2-1f1fd.png',
      value: 'es-mx'
    },
    {
      flag: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/flag-for-turkey_1f1f9-1f1f7.png',
      value: 'tr-tr'
    }
  ]
}
